module.exports = __webpack_public_path__ + "static/media/2021recap-watermark.072d9674.svg";